module.exports = __webpack_public_path__ + "static/img/6.c9790d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/6.png
// module id = m2m5
// module chunks = 0